import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c88cf890"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hidden-lg hidden-md",
  style: {"height":"10px"}
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "tick-icon glyphicon glyphicon-ok",
  "data-test": "tick-ok-icon"
}, null, -1))
const _hoisted_3 = {
  class: "complete-button-text",
  "data-test": "complete-button-text"
}

import { computed } from "vue";
import {
  CmsPersonalPathwayStep,
  CmsSessionWithSlides,
  CmsTeamPathwayStep,
} from "../../services/cms/cms-type-definitions";

export type CmsSessionDoc = CmsSessionWithSlides | CmsTeamPathwayStep | CmsPersonalPathwayStep;

type SessionCompleteButtonProps = {
  ready?: boolean;
  canCompletePathwayStep?: boolean;
  completed?: boolean;
  currentStepWasAlreadyComplete?: boolean;
  isForPathwayStep: boolean;
  completeButtonText: string;
  buttonLink?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'session-complete-button',
  props: {
    buttonProps: {},
    showCloseButton: { type: Boolean }
  },
  emits: ["close", "complete"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const displayButton = computed<boolean>(() => {
  const { buttonProps } = props;

  if (buttonProps.isForPathwayStep) {
    return !!buttonProps.ready && (!!buttonProps.canCompletePathwayStep || !!buttonProps.completed);
  }

  return true;
});

const close = (): void => {
  emit("close");
};

const complete = (): void => {
  emit("complete");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (props.showCloseButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          style: {"width":"12.5em","min-height":"3em","margin-bottom":"10px"},
          class: "btn btn-lg btn-default",
          "data-test": "session-close-button",
          onClick: close,
          type: "button"
        }, " Close "))
      : _createCommentVNode("", true),
    _createTextVNode("   "),
    _hoisted_1,
    (displayButton.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (complete())),
          ref: "completeButton",
          class: _normalizeClass(["complete-button btn btn-lg btn-primary", {
        'completed': props.buttonProps.completed,
        'already-completed': props.buttonProps.currentStepWasAlreadyComplete,
      }]),
          "data-test": "session-complete-button",
          type: "button"
        }, [
          _hoisted_2,
          _createElementVNode("span", _hoisted_3, _toDisplayString(props.buttonProps.completeButtonText), 1)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})